import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/red_packet_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  brand_name_cont: {
    model_name: 'Brand',
    column_type: 'string',
    column_name: 'name',
  },
  code_cont: {
    model_name: 'RedPacket',
    column_type: 'string',
    column_name: 'code',
  },
  type_eq: {
    column_type: 'type',
    extra: {
      options: [],
    },
    model_name: 'RedPacket',
    column_name: 'type',
  },
  type_not_eq: {
    column_type: 'type',
    extra: {
      options: [],
    },
    model_name: 'RedPacket',
    column_name: 'type',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'RedPacket',
      options: ['init', 'actived', 'completed', 'expired'],
    },
    model_name: 'RedPacket',
    column_name: 'state',
  },
  expired_at_gteq_datetime: {
    column_type: 'datetime',
    model_name: 'RedPacket',
    column_name: 'expiredAt',
  },
  expired_at_lteq_datetime: {
    column_type: 'datetime',
    model_name: 'RedPacket',
    column_name: 'expiredAt',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'RedPacket',
      options: ['cash', 'cashback'],
    },
    model_name: 'RedPacket',
    column_name: 'kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'type': { required: true, disabledUpdate: false },
    'code': { required: true, disabledUpdate: false },
    'total_amount': { required: true, disabledUpdate: false },
    'quantity': { required: false, disabledUpdate: false },
    'expired_at': { required: true, disabledUpdate: false },
    'brand_id': { required: true, disabledUpdate: false },
    'kind': { required: true, disabledUpdate: false },
    'limit_one_person_total_receive_count': { required: false, disabledUpdate: false },
    'limit_one_person_receive_count_per_day': { required: false, disabledUpdate: false },
    'custom_list_item_attributes': { required: false, disabledUpdate: false },
  },
  'custom_list_item_attributes': {
    'id': { required: false, disabledUpdate: true },
    'target_type': { required: false, disabledUpdate: true },
    'target_id': { required: false, disabledUpdate: true },
    'external_link': { required: false, disabledUpdate: true },
    'image': { required: false, disabledUpdate: true },
    'video': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('RedPacket', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('RedPacket', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
